﻿let eventRepository = require('../eventRepository');
let moment = require('moment');
let _ = require('lodash');
let URI = require('urijs');

module.exports = EventsList;

const NationalRegion = 'National';

function EventsList(customOptions) {
    let defaultOptions = {
        region: null,
        date: moment(),
        listElement: null,
        listType: null,
        upcomingEventsRegion: null,
        upcomingEventsCount: null
    }

    let options = $.extend({}, defaultOptions, customOptions);
    _.assign(this, options);

    this.registerDateSelectedObserver();
    $(document).on('regionsFilterChange', (event, params) => {
        this.region = params.regionName;
        this.renderEventsListContent();
    });

    
    this.initializeList();
}

EventsList.prototype = {
    initializeList() {
        if (this.listType == 'upcoming') {
            eventRepository.getUpcomingEvents(this.upcomingEventsCount, this.upcomingEventsRegion)
                .then(events => _.orderBy(events, 'StartDate'))
                .then(events => this.setEvents(events))
                .done();

        } else {
            $.ajax({
                url: jnfroutesconfg.EventsApi,
                data: {
                    year: this.date.year(),
                    month: this.date.month() + 1,
                    day: this.date.date()
                },
                success: events => this.setEvents(events),
                error: console.log
            });

        }
    },

    setEvents(events) {
        this.events = events;
        this.renderEventsListContent();
    },

    registerDateSelectedObserver() {
        var observer = { notify: date => this.onDateSelected(date) };

        if (!window.eventsListChangedObservers) {
            window.dateSelectedObservers = [observer];
        } else {
            window.dateSelectedObservers.append(observer);
        }
    },

    onDateSelected(date) {
        let year = date.year();
        let month = date.month() + 1;
        
        eventRepository.getEventsForMonth(year, month)
            .then(events => events.filter(event =>
                date.isSameOrAfter(event.StartDate, 'day') && date.isSameOrBefore(event.EndDate, 'day')
            ))
            .then(events => this.setEvents(events))
            .done();
    },

    renderEventsListContent() {
        let events = _.filter(this.events, event => this.shouldDisplayEvent(event));

        this.listElement.empty();
        if (events.length) {
            var listElements = events.map(event => this.renderEventListElement(event));
            this.listElement.append(listElements);

        } else {
            var emptyListMessage = this.renderEmptyListMessage();
            this.listElement.append(emptyListMessage);
        }
    },

    shouldDisplayEvent(event) {
        return !this.region || event.Region === NationalRegion || event.Region === this.region;
    },

    renderEventListElement(event) {
        var element = $('<li></li>');
        element.append(this.renderEventDate(event));
        element.append(this.renderEventDetails(event));

        return element;
    },

    renderEmptyListMessage() {
        return $('<li>There are no upcoming events.</li>')
    },

    renderEventDate(event) {
        var date = moment.utc(event.StartDate);

        var dayOfWeek = date.format('dddd');

        var container = $('<div class="date-container">');
        container.append('<div class="day-of-week">' + date.format('dddd') + '</div>');
        container.append('<div class="month">' + date.format('MMM') + '</div>');
        container.append('<div class="day-of-month">' + date.format('DD') + '</div>');
        container.append('<div class="hour">' + date.format('h:mma') + '</div>');

        return container;
    },

    renderEventDetails(event) {       

        let registrationLink = this.getEventRegistrationUrl(event);

        var container = $('<div class="details-container">');

        container.append(this.renderEventName(event));
        container.append(this.renderEventLocation(event));
        container.append(this.renderEventDescription(event));
        container.append('<div class="registration-link"><a href="' + registrationLink + '">Register</a></div>');

        return container;
    },

    renderEventName(event) {
        let nameSection = $('<div class="event-name">' + (event.Name || '') + '</div>');

        if (event.EventPageUrl) {
            let link = $(`<a href='${event.EventPageUrl}'></a>`);
            link.append(nameSection);
            nameSection = link;
        }

        return nameSection;
    },

    renderEventLocation(event) {
        var location = event.City;
        if (event.Street && location) {
            location = event.Street + ', ' + location;
        }
        if (event.LocationName && location) {
            location = event.LocationName + ', ' + location
        }

        return $(`<div class="event-location">${location || ''}</div>`);
    },

    renderEventDescription(event) {
        return event.Description ? `<div class="event-description">${event.Description}</div>` : '';        
    },

    getEventRegistrationUrl(event) {
        let isPastEvent = moment().isSameOrAfter(event.StartDate, 'day');

        return new URI(eventRegistrationPageUrl).addQuery({
            id: event.Id
        });
    }
}